import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { EVENTS } from '~/src/constants/analytics';

const VideoYouTubeWrapper = styled.div`
  display: block;
  width: 100%; 
`;

const VideoYouTubeRatioCorrector = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: ${props => (props.ratio * 100) + '%'}; 
`;

const VideoYouTubeIframe = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;  
`;

/* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */

const VideoYouTube = ({ videoId, ratio = 0.5625, eventLabel }) => {
    const statePlay = 1;
    const iframeId = 'VideoYouTube';
    const [apiLoaded, setApiLoaded] = useState(false);
    const [played, setPlayed] = useState(false);
    const [player, setPlayer] = useState();

    const onPlayerStateChange = (event) => {
        if (eventLabel && statePlay === event.data && !played) {
            setPlayed(true);
            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'video',
                action: 'get',
                label: eventLabel || videoId
            });
        }
    };

    useEffect(() => {
        if (typeof YT === 'undefined') {
            if (!apiLoaded) {
                if (!window.onYouTubeIframeAPIReady) {
                    window.onYouTubeIframeAPIReady = () => {
                        setApiLoaded(true);
                    };
                }

                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.async = true;
                document.body.appendChild(script);
            }
        } else if (!player) {
            setPlayer(
                // eslint-disable-next-line
                new YT.Player(iframeId, {
                    videoId: videoId,
                    events: {
                        'onStateChange': onPlayerStateChange,
                    }
                })
            );
        }
    });

    return (
        <VideoYouTubeWrapper>
            <VideoYouTubeRatioCorrector
                ratio={ratio}
            >
                <VideoYouTubeIframe id={iframeId}/>
            </VideoYouTubeRatioCorrector>
        </VideoYouTubeWrapper>
    );
};

export default VideoYouTube;
